export const DEFAULT_TITLE = "Annuity Ready";
export const TITLE_SECONDARY = "Annuity Rates Comparison";
export const ONLINE_INCOME_COMPARISON = "Online Annuity Income Comparison";
export const LOGIN_TITLE = `${DEFAULT_TITLE} | Login`;
export const RESULT_APPLY_TITLE = `${TITLE_SECONDARY} | ${ONLINE_INCOME_COMPARISON}`;
